import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useOfferConfirmMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

export const offerConfirmModal: any = {};

export const OfferConfirmModal = () => {
  const { mutate } = useOfferConfirmMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    offerConfirmModal.open = () => {
      offerConfirmModal.action = offerConfirmModal.isAccept ? 'Accepting' : 'Rejecting';
      offerConfirmModal.name = `You are ${offerConfirmModal.action} the $${offerConfirmModal.price} offer for this container ${offerConfirmModal.number}`;

      offerConfirmModal.isSubmitClicked = false;
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(offerConfirmModal).forEach((key) => {
      if (key !== 'open') delete offerConfirmModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      { id: offerConfirmModal.id, isConfirm: offerConfirmModal.isAccept },
      {
        onSuccess: () => {
          setOpen(false);
          offerConfirmModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.OFFER.ERROR.NOT_CONFIRMED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'offer-confirm-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {offerConfirmModal.name}
        </Typography>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.confirm')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
